import { featureFlagsSelectors } from 'store/featureFlags/selectors';
import { saleSelectors } from 'store/sale/selectors';

type SelectorState = {
  featureFlags: Record<string, boolean>;
  sale?: any;
};

export const isSurchargePaintedDoorOnForSale = (state: SelectorState): boolean => {
  const sale = state?.sale;
  const featureFlagIsOn = featureFlagsSelectors.isSurchargePaintedDoorEnabled(state);
  const experimentEnabled = saleSelectors.surchargeExperimentEnabledSelector(sale);
  return featureFlagIsOn && experimentEnabled;
};

export const getSurchargeFeeAmountIfEnabled = (state: SelectorState): number | undefined => {
  const sale = state?.sale;
  if (!isSurchargePaintedDoorOnForSale(state)) {
    return undefined;
  }
  const feeAmount = saleSelectors.surchargeFeeAmountSelector(sale);
  return feeAmount;
};

export const getSurchargeFeePercentageIfEnabled = (state: SelectorState): string | undefined => {
  const sale = state?.sale;
  if (!isSurchargePaintedDoorOnForSale(state)) {
    return undefined;
  }
  return saleSelectors.surchargeFeePercentageSelector(sale);
};

export const getSurchargeTotalAmountWithFeeIfEnabled = (
  state: SelectorState
): number | undefined => {
  const sale = state?.sale;
  if (!isSurchargePaintedDoorOnForSale(state)) {
    return undefined;
  }
  return saleSelectors.surchargeTotalAmountWithFeeSelector(sale);
};

/**
 * Returns whether the invoice amount is over 125.
 * Special rule: if both cc.enabled and ach.enabled are true, return true.
 */
export const shouldShowACHEnabledOnRefresh = (state: SelectorState): boolean => {
  if (!isSurchargePaintedDoorOnForSale(state)) return false;
  const sale = state?.sale;
  const achEnabled = saleSelectors.achOnlineConvenienceFeeEnabledSelector(sale);
  if (achEnabled) {
    return true;
  }
  return false;
};

export const getSurchargeAllData = (state: SelectorState): boolean => {
  const sale = state?.sale;
  const featureFlagIsOn = featureFlagsSelectors.isSurchargePaintedDoorEnabled(state);
  const experimentEnabled = saleSelectors.surchargeExperimentEnabledSelector(sale);

  return {
    featureFlagIsOn,
    experimentEnabled,
    cc: saleSelectors.surchargeSelector(sale),
    ach: saleSelectors.achSelector(sale),
  } as any;
};

export const isSurchargeControlGroupForSale = (state: SelectorState): boolean => {
  const sale = state?.sale;
  const featureFlagIsOn = featureFlagsSelectors.isSurchargePaintedDoorEnabled(state);
  const experimentEnabled = saleSelectors.surchargeExperimentEnabledSelector(sale);
  const bucketName = saleSelectors.surchargeExperimentBucketNameSelector(sale);
  return featureFlagIsOn && !experimentEnabled && bucketName === 'surcharge_test_control';
};
